export default "__VITE_ASSET__CIXOpYAS__"